import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import LandingPage from '@/pages/LandingPage';
import AuthPage from '@/pages/AuthPage';
import ChatPage from '@/pages/ChatPage';
import SettingsPage from '@/pages/SettingsPage';
import ImportPage from '@/pages/ImportPage';
import WorkspacePage from '@/pages/WorkspacePage';
import AgentHistoryPage from '@/pages/AgentHistoryPage';
import AdminPurchasesPage from '@/pages/AdminPurchasesPage';
import SharePage from '@/pages/SharePage';
import { Toaster } from '@/components/ui/sonner';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3">
        <div className="w-5 h-5 border-2 border-gray-200 border-t-lime-500 rounded-full animate-spin" />
      </div>
    </div>
  );
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-5 h-5 border-2 border-gray-200 border-t-lime-500 rounded-full animate-spin" />
    </div>
  );
  if (user && user !== false) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/share/:shareId" element={<SharePage />} />
          <Route path="/auth" element={<PublicRoute><AuthPage /></PublicRoute>} />
          <Route path="/app/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/app/import" element={<ProtectedRoute><ImportPage /></ProtectedRoute>} />
          <Route path="/app/workspaces" element={<ProtectedRoute><WorkspacePage /></ProtectedRoute>} />
          <Route path="/app/agent-history" element={<ProtectedRoute><AgentHistoryPage /></ProtectedRoute>} />
          <Route path="/app/admin/purchases" element={<ProtectedRoute><AdminPurchasesPage /></ProtectedRoute>} />
          <Route path="/app" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
